import api from "@/api";

const MicrosoftService = {
    async login() {
        const response = await api.get(process.env.VUE_APP_API_URL + 'microsoft/login');

        return response.data;
    }
};

export default MicrosoftService;